<template>
  <div class="recent-updates">
    <h3>Recent Updates</h3>
    <p class="loading-notice text-muted" v-if="loading"><i class="fa fa-circle-o-notch fa-spin"/>&nbsp;Loading recent updates...</p>
    <div
      class="alert alert-danger"
      role="alert"
      v-if="error">Error loading recent updates. Please refresh the page and try again.</div>
    <ul>
      <li
        class="post-li"
        v-for="post, idx in posts"
        :key="post.id">
        <a
          :href="post.fields.url"
          rel="noopener"
          target="_blank"
          @click="trackLinkClick('Clicked Post Link', {ref: 'home', title: post.fields.title, URL: post.fields.url, position: idx + 1})">
          <span class="sr-only">Blog post:</span>
          {{ post.fields.title }}
          <span class="sr-only">(opens in a new tab)</span>
        </a>
      </li>
    </ul>
    <a
      :href="toolkitUpdates"
      target="_blank"
      rel="noopener"
      @click="trackLinkClick('Clicked View All Posts', {ref: 'home'})"
    >
      View all updates
      <span class="sr-only">(opens in a new tab)</span>
    </a>
  </div>
</template>

<script>
import { getBlogPosts } from '@/api/homepage'
import { toolkitUrls } from '@/links'
import homeMixin from '@/components/home/mixins'

export default {
    name: 'RecentUpdates',
    mixins: [homeMixin],
    data() {
        return {
            loading: true,
            error: false,
            posts: null,
            ...toolkitUrls,
        }
    },
    methods: {
        async getPosts() {
            try {
                const data = await getBlogPosts('common-core')
                if (data.length) {
                    this.updatePostData(data)
                }
                this.loading = false
            } catch (err) {
                console.error(err)
                this.updatesError = true
                this.loading = false
            }
        },
        updatePostData(data) {
            data.shift() // The first element in data is not a blog post
            this.posts = data
        }
    },
    created() {
        this.getPosts()
    }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';

h3 {
    color: @header-text-dark;
    font-size: 1.2rem;
}
a:focus {
    outline: 2px solid lighten(@link-color, 20%);;
    outline-offset: 3px;
}
.loading-notice {
  font-size: 1rem;
}
.webinars, .recent-updates {
    margin-left: 1rem;
}
.recent-updates > h3 {
    margin-top: 40px;
    margin-bottom: 10px;
    @media (min-width: @screen-sm) and (max-width: @screen-lg) {
      margin-top: 0;
    }
}
.recent-updates > ul {
    list-style: none;
    padding: 0;

    & > li {
        font-size: 1rem;
        margin-bottom: 1rem;
    }

}

</style>
